import { Button } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { AppleSignInButton } from 'src/Components/Auth/AppleSignInButton';
import { FacebookSignInButton } from 'src/Components/Auth/FacebookSignInButton';
import { GoogleSignInButton } from 'src/Components/Auth/GoogleSignInButton';
import SignInForm from 'src/Components/Forms/SignInForm';
import { FullScreenFormWrapper } from 'src/Containers/FullScreenFormWrapper';
import useIsMobile from 'src/Hooks/Shared/useIsMobile';

import styles from './SignInPage.module.scss';

const SignInPage = () => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  const thirdPartyAuthSection = (
    <>
      {!isMobile && (
        <div className={styles.orLine}>
          <div className={styles.line} />
          <div className={styles.or}>{t('auth.or', 'ou')}</div>
          <div className={styles.line} />
        </div>
      )}

      <div className={styles.thirdPartyButtons}>
        <GoogleSignInButton compact={isMobile} />
        <FacebookSignInButton compact={isMobile} />
        <AppleSignInButton compact={isMobile} />
      </div>

      {isMobile && (
        <div className={styles.orLineMobile}>
          <div className={styles.line} />
          <div className={styles.or}>{t('auth.or', 'ou')}</div>
          <div className={styles.line} />
        </div>
      )}
    </>
  );

  return (
    <FullScreenFormWrapper maxWidth={400}>
      {isMobile && thirdPartyAuthSection}
      <SignInForm />
      {!isMobile && thirdPartyAuthSection}

      <div className={styles.footer}>
        <p className={styles.footerText}>
          {t(
            'signinForm.dataProtection',
            '🔒 Connexion SSL sécurisée. Vos données sont cryptées et protégées 24h/24 au titre du secret patrimonial.'
          )}
        </p>
        <p className={styles.footerText}>
          {t('signinForm.needHelp', 'Besoin d\u2019aide ? Notre équipe est à votre écoute.')}
        </p>
        <Button
          component="a"
          href="https://www.shareheritage.com/contact-shareheritage"
          target="_blank"
          rel="noopener noreferrer"
          variant="outline"
          className={styles.contactButton}
        >
          {t('signinForm.contact', 'Contact')}
        </Button>
      </div>
    </FullScreenFormWrapper>
  );
};

export default SignInPage;
